module.exports = __webpack_public_path__ + "img/sound-start.7fdbbb48.png";